import { css } from '@emotion/core';
import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';
import { useHeadingLevel } from '@zapier/heading-level-context';
import { clamp } from '../../../utils/clamp';
const Styles = labelStyles('Heading', {
    root: css `
    display: block;
  `,
});
export const Heading = (props) => {
    const { level } = useHeadingLevel();
    const headingLevel = clamp(level, 1, 6);
    const Tag = `h${headingLevel}`;
    return (isolateComponent(Tag, { css: Styles.root, className: props.className }, props.children));
};
//# sourceMappingURL=Heading.js.map
// @zapier/design-system@5.18.1 (f78072c92)
